import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import TitleBox from '../../components/common/breadcrumbs/TitleBox';
import PartnerStepperTemplate from '../../components/partnermng/PartnerStepperTemplate';

const PartnerAddContainer = ({ handleClose, isModal }) => {
  let navigate = useNavigate();
  const [titleData, setTitleData] = useState({ name: "거래처 신규 추가" });
  
  const handleGoBack = () => {
    navigate('/partnermng');
  };

  return (
    <>
      {!isModal && (
        <TitleBox
          handleGoBack={handleGoBack}
          menuName="마스터/거래처 관리/추가"
          menuLink="/partnermng"
          icon="partner"
          titleData={titleData}
        />
      )}
      <Box
        sx={{
          mt: isModal ? 0 : 2
        }}
      >
         <PartnerStepperTemplate handleClose={handleClose} isModal={isModal} />
      </Box>
    </>
  );
};

export default PartnerAddContainer;
